export const saveLoginProviderData = (provider) => {
  return {
    type: 'SAVE_LOGIN_PROVIDER',
    payload: {provider}
  };
};
